import { render, staticRenderFns } from "./IzinTamuViewEmail.vue?vue&type=template&id=6d95d724&scoped=true&lang=pug&"
import script from "./IzinTamuViewEmail.vue?vue&type=script&lang=js&"
export * from "./IzinTamuViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./IzinTamuViewEmail.vue?vue&type=style&index=0&id=6d95d724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d95d724",
  null
  
)

export default component.exports